import ListAltIcon from '@mui/icons-material/ListAlt';
import { Grid } from '@mui/material';
import { useState } from 'react';
import { GenericNameModal } from 'v3/shared/components/Modal/GenericNameModal';
import { BodySmallBold, BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { theme } from 'v3/styles/global-styles';
import { IconHeader } from '../IconHeader';
import { AlignLeft, ContainerStores, Content, DivBreakWord, EditIconStyled, Header } from '../styles';

interface StoreInformationProps {
  name?: string;
  email?: string;
  onNameChange?: (newName: string) => void;
}

export const StoreInformation: React.FC<StoreInformationProps> = ({ name, email, onNameChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEditClick = () => {
    setIsModalOpen(true);
  };

  const handleSaveName = (newName: string) => {
    if (onNameChange) {
      onNameChange(newName);
    }
    setIsModalOpen(false);
  };

  return (
    <ContainerStores>
      <Header>
        <AlignLeft>
          <IconHeader Icon={ListAltIcon} />
          <SubtitleLarge>Informações da loja</SubtitleLarge>
        </AlignLeft>
        <EditIconStyled onClick={handleEditClick} />
      </Header>
      <Content>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid size={{ xs: 6 }} component="div">
            <DivBreakWord>
              <BodySmallRegular color={theme.palette.secondary.light}>Nome da loja</BodySmallRegular>
              <BodySmallBold>{name ?? '-'}</BodySmallBold>
            </DivBreakWord>
          </Grid>
          <Grid size={{ xs: 6 }} component="div">
            <DivBreakWord>
              <BodySmallRegular color={theme.palette.secondary.light}>E-mail</BodySmallRegular>
              <BodySmallBold>{email ?? '-'}</BodySmallBold>
            </DivBreakWord>
          </Grid>
        </Grid>
      </Content>
      <GenericNameModal
        title="Editar nome da loja"
        active={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        currentName={name}
        onSave={handleSaveName}
      />
    </ContainerStores>
  );
};
